import { useState } from 'react';
import { Roles, SideNavItems } from '../../utils/constants/RoleConstants';
import SideNavTabButton from './SideNavTabButton';
import useAuthContext from '../../apps/common/modules/auth/hooks/useAuthContext';
import { IGenericSetState } from '../../utils/Interface/CommonInterface';
import Constants from '../../utils/Constants';
import { useAppSelector } from '../../Redux/Store';
import { commonFeatures } from '../../apps/common/featureFlags/commonFeatures';

const { isCA13765On_TokenManagementRework } = commonFeatures;

const SideNavTab = ({
    setSideNavTab,
}: {
    setSideNavTab: IGenericSetState<string | number>;
}) => {
    const currentSelectedTab = useAppSelector(
        state => state.common.currentSelectedTab,
    );
    const [active, setActive] = useState<string | number>('');
    const {
        getUsersAppSubscriptions,
        isAuthenticated,
        getUsersRoles,
        hasTenantId,
    } = useAuthContext();
    const handleActive = (data: number | string) => {
        setActive(data);
    };
    const usersAppSubscriptions = getUsersAppSubscriptions();
    const usersRoles = getUsersRoles();

    return (
        <div className="sidebar-tabs d-flex justify-content-between">
            {isAuthenticated() &&
                hasTenantId() &&
                Object.values(SideNavItems)
                    .filter(item => item.isAppEnabled)
                    .filter(
                        item =>
                            usersRoles.includes(Roles.ADMIN) ||
                            usersAppSubscriptions.includes(item.appRole),
                    )
                    .filter(
                        item =>
                            localStorage.getItem(
                                Constants.StorageItems.AUTH_TYPE,
                            ) === Constants.AuthType.LOCAL ||
                            item.roles.some(role => usersRoles.includes(role)),
                    )
                    .map((item, index) => (
                        <SideNavTabButton
                            key={index}
                            active={
                                isCA13765On_TokenManagementRework
                                    ? currentSelectedTab === item.state
                                    : active === index
                            }
                            handleActive={handleActive}
                            usersRoles={usersRoles}
                            id={index}
                            item={item}
                            setSideNavTab={setSideNavTab}
                        />
                    ))}
        </div>
    );
};

export default SideNavTab;
